import axios from 'axios';
import { pca } from '../index';
import { tokenRequest } from '../config/authConfig';


const requestConfig = {
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}
};

const instance = axios.create(requestConfig);

instance.interceptors.request.use(
    async config => {
        const account = pca.getAllAccounts()[0];

        if (!account) {
            throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }

        const response = await pca.acquireTokenSilent({
            ...tokenRequest,
            account: account
        });

        config.headers = {
            'Authorization': `Bearer ${response.accessToken}`
        };
        return config;
    },
    error => {
        console.log("request interceptor error: ", error);
        return Promise.reject(error);
    }
);
instance.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    console.log("error in resp interceptor: ", error);
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
        console.log("error in response interceptor");
        window.location.href = `${process.env.REACT_APP_BASE_HREF}/four-oh-three`;
    }
    return Promise.reject(error);
});

class ApiClient {
    constructor(instance) {
        this.apiClientInstance = instance;
    }

    //Get all route stops for the given date (defaults today)
    async getAllRouteStops(routeDate = undefined) {
        let requestUrl = '';
        if (routeDate !== undefined){
            requestUrl = `/routes?routeDate=${routeDate}`;
        } else {
            requestUrl = '/routes';
        }
        try {
            let response = await this.apiClientInstance.get(requestUrl);
            return response.data;
        } catch (error) {
            console.log("Error getting all routes: ", error);
        }
    }


    //Get the loadout for a specified route number
    async getLoadoutForRoute(routeNumber) {
        try {
            let response = await this.apiClientInstance.get(`/routes/${routeNumber}/loadout`);
            return response.data;
        } catch (error) {
            console.log("Error getting loadout: ", error);
        }
    }

    //Get the FA Details from CC&B
    async getFieldActivityDetails(faId) {
        try {
            let response = await this.apiClientInstance.get(`/ccb/field-activity/${faId}`);
            return response;
        } catch (error) {
            // Error
            console.log("in error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
            console.log(error);
        }
    }

    //Get FA logs from CC&B
    async getFieldActivityLog(faId) {
        try {
            let response = await this.apiClientInstance.get(`/ccb/field-activity/${faId}/logs`);
            return response;
        } catch (error) {
            // Error
            console.log("in get FA log error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }

    //Get CC&B last log sequence number for a provided FA Id
    async getLastLogSequenceNumber(faId) {
        try {
            let response = await this.apiClientInstance.get(`/ccb/field-activity/${faId}/logs/last-sequence`);
            return response.data;
        } catch (error) {
            console.log('Error getting CC&B last log sequence number: ', error);
        }
    }

    //Add to a CC&B FA log
    async postToFieldActivityLog(faId, seqNum, logMessage) {
        //console.log("post log values: ", `faId: ${faId}, seqNum: ${seqNum}, logMessage: ${logMessage}`);
        try {
            let response = await this.apiClientInstance.post('/ccb/field-activity/logs/update', {
                "FieldActivityId": faId,
                "SequenceNumber": seqNum,
                "LogMessage": logMessage
            });
            return response;
        } catch (error) {
            // Error
            console.log("in post FA log error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }

    }

    //Complete FA in CC&B, passing FA Id and fa remark
    async completeFieldActivity(faId, timeStamp, faRemark) {
        try {
            let response = await this.apiClientInstance.post(`/ccb/field-activity/complete`, {
                "FieldActivityId": faId,
                "TimeStamp": timeStamp,
                "Remark": faRemark
            });
            return response;
        } catch (error) {
            // Error
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }


    //Get the SWC and Incident GUIDS for a provided SR number
    async getSwcAndIncidentIDs(srNumber) {
        try {
            let response = await this.apiClientInstance.post(`/flows/power-automate/${srNumber}/swc/ids`, {
                "srNumber": srNumber
            });
            return response;
        } catch (error) {
            // Error
            console.log("in get SWC IDs error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }

    //This action is no longer necessary after updating the ForemanInvestigate flow
    //Update Dynamics entity closure status value
    //THIS IS A FLOW CALL
    // async updateDynamicsSwcFaStatus(srNumber, faClosureStatus) {
    //     try {
    //         //don't send APIM auth
    //         delete this.apiClientInstance.defaults.headers.common['Ocp-Apim-Subscription-Key'];
    //         let response = await this.apiClientInstance.post(UPDATE_DYNAMICS_SWC_FA_STATUS_FLOW_URL, {
    //             "ServiceRequestNumber_Value": srNumber,
    //             "FAClosureStatus_Value": faClosureStatus
    //         });
    //         return response;
    //     } catch (error) {
    //         console.log("Error updatng dynamics swc fa status: ", error);
    //     }
    // }

    //Update Dynamics entity status
    //THIS IS A FLOW CALL
    async closeDynamicsEntity(srNumber, closureType, faId, ccbPersonId, faClosureStatus) {
        //console.log("sr, closureType, faId, ccbPersonId, faClosureStatus: ", srNumber)
        try {
            let response = await this.apiClientInstance.post('/flows/power-automate/swc/dynamics/close', {
                "ServiceRequestNumber": srNumber,
                "ClosureType": closureType,
                "FieldActivityId": faId,
                "CcbPersonId": ccbPersonId,
                "FieldActivityClosureStatus": faClosureStatus
            });
            return response;
        } catch (error) {
            // Error
            console.log("in close dynamics entity error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }

    //Upload CNO photo to CRM
    //THIS IS A FLOW CALL
    async uploadCnoPhoto(srNumber, fileContent, swcId, timeStamp) {
        //let nowFormatted = Moment().format('YYYY-MM-DD-HH-mm-ss');
        let fileName = `${timeStamp}-CNO.jpg`;

        try {

            let response = await this.apiClientInstance.post('/flows/power-automate/swc/photo', {
                "ServiceRequestNumber": srNumber,
                "FileName": fileName,
                "FileContent": fileContent,
                "SolidWasteContainerId": swcId
            });
            return response;
        } catch (error) {
            // Error
            console.log("in upload CNO photo error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }


    //Update CRM entity in the case of CNO
    //THIS IS A FLOW CALL
    async updateCnoInCrm(srNumber, faId, ccbPersonId, photoId) {
        try {

            let response = await this.apiClientInstance.post('/flows/power-automate/swc/dynamics/cno', {
                "ServiceRequestNumber": srNumber,
                "FieldActivityId": faId,
                "CcbPersonId": ccbPersonId,
                "PhotoId": photoId
            });
            return response;
        } catch (error) {
            // Error
            console.log("in CNO in CRM error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }

    //Additional process in the case of CNO without associated CRM
    //THIS IS A FLOW CALL
    async updateCnoForCcb(faId, ccbCustomerId) {
        try {

            let response = await this.apiClientInstance.post('/flows/power-automate/swc/ccb/cno', {
                "FieldActivityId": faId,
                "CcbPersonId": ccbCustomerId,
            });
            return response;
        } catch (error) {
            // Error
            console.log("in update CNO for CCB error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }

    //Handle choice of Foreman Investigate
    //THIS IS A FLOW CALL
    async foremanInvestigate(srNumber, faId, userName, faClosureStatus) {
        try {

            let response = await this.apiClientInstance.post('/flows/power-automate/swc/foreman-investigate', {
                "ServiceRequestNumber": srNumber,
                "FieldActivityId": faId,
                "UserName": userName,
                "FieldActivityClosureStatus": faClosureStatus
            });
            return response;
        } catch (error) {
            // Error
            console.log("in Foreman Investigate error catch: ", error);
            if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                return error.response;
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
            }
        }
    }

}



export default new ApiClient(instance);



